import api from "./AxiosInterceptor";
import EndpointService from "./EndpointService";

export const getVerificationMethodsService = async () => {
  const url = EndpointService("verificationMethods");
  const response = await api.get(url);
  return response;
};

export const postAuthenticateService = async (payload) => {
  const url = EndpointService("authenticate");
  const response = await api.post(url, payload);
  return response;
};

export const postIdentifyUserService = async (payload, action) => {
  const url = EndpointService("identifyUser").replace("{action}", action);
  const response = await api.post(url, payload);
  return response;
};

export const putAccountService = async (payload) => {
  const url = EndpointService("putAccount");
  const response = await api.put(url, payload);
  return response;
};

export const postSendOTPService = async (payload) => {
  const url = EndpointService("sendOtp");
  const response = await api.post(url, payload);
  return response;
};

export const postLoginValidateOTPService = async (payload) => {
  const url = EndpointService("validateOTP");
  const response = await api.post(url, payload);
  return response;
};

export const postForgotUsernameService = async (data) => {
  const url = EndpointService("forgotUsername");
  const response = await api.post(url, data);
  return response;
};

export const getAccountDetailsService = async () => {
  const url = EndpointService("getAccountDetails");
  const response = await api.get(url);
  return response;
};

export const putSelfEnableService = async () => {
  const url = EndpointService("selfEnable");
  const response = await api.put(url);
  return response;
};

export const putVerificationMethodService = async (data) => {
  const url = EndpointService("putVerificationMethod");
  const response = await api.put(url, data);
  return response;
};

export const postRegisterEditVerificationMethodService = async (
  data,
  action
) => {
  const url = EndpointService("registerVerificationMethod").replace(
    "{action}",
    action
  );
  const response = await api.post(url, data);
  return response;
};

export const postForgotPasswordService = async (data) => {
  const url = EndpointService("forgotPassword");
  const response = await api.post(url, data);
  return response;
};

export const postResetForgotPasswordService = async (data) => {
  const url = EndpointService("resetForgotPassword");
  const response = await api.post(url, data);
  return response;
};

export const postResetPasswordService = async (data) => {
  const url = EndpointService("passwordExpiryReset");
  const response = await api.post(url, data);
  return response;
};

export const postNewPasswordService = async (data, apiAction) => {
  const url = EndpointService("newPassword").replace("{action}", apiAction);
  const response = await api.post(url, data);
  return response;
};

export const postVerificationMethodService = async (data, action) => {
  const url = EndpointService("verificationMethod").replace("{action}", action);
  const response = await api.post(url, data);
  return response;
};

export const postRemoveVerificationMethodService = async (data, action) => {
  const url = EndpointService("removeVerificationMethod").replace(
    "{action}",
    action
  );
  const response = await api.post(url, data);
  return response;
};
